import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { TASK_SUB_CATEGORY_API } from "../apiRoutes";

const getSubCategories = async () => {
  return await axiosAuth.get(`${TASK_SUB_CATEGORY_API}`);
};

const useGetSubCategories = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["sub-categories"],
    queryFn: () => getSubCategories(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetSubCategories;
